export default "__VITE_ASSET__AnVwxwOJ__"